import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AccountSelectors } from '@core/account-data';
import { BillingPlanTier } from '@core/billing-types';
import {
  FeatureGuardDialogComponent,
  FrontendOnlyGuardedFeature,
} from '@core/feature-guard-legacy';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';
import { isBillingPlanLegacy } from '@recruitee/billing-util';

@Injectable({
  providedIn: 'root',
})
export class AutomationsFeatureGuardService {
  private readonly store = inject(Store);
  private readonly dialogService = inject(DialogService);

  private readonly currentPlanTier = this.store.selectSignal(AccountSelectors.productCodename);

  public getAutomationsFeatureGuardDialog(featureGuard?: FrontendOnlyGuardedFeature) {
    const feature = this.getFeature(featureGuard);
    switch (feature) {
      case FrontendOnlyGuardedFeature.WorkflowAutomationsNewPlans:
        this.dialogService.openCustom(
          FeatureGuardDialogComponent,
          {
            width: DialogWidth.Small,
          },
          {
            frontendFeature: FrontendOnlyGuardedFeature.WorkflowAutomationsNewPlans,
            availableInNewPlans: true,
          },
        );
        break;
      case FrontendOnlyGuardedFeature.WorkflowAutomationsAdvance:
        this.dialogService.openCustom(
          FeatureGuardDialogComponent,
          {
            width: DialogWidth.Small,
          },
          {
            frontendFeature: FrontendOnlyGuardedFeature.WorkflowAutomationsAdvance,
            availableFromPlanOverwrite: BillingPlanTier.Grow,
          },
        );
        break;
      case FrontendOnlyGuardedFeature.WorkflowAutomationsOptimize:
        this.dialogService.openCustom(
          FeatureGuardDialogComponent,
          {
            width: DialogWidth.Small,
          },
          {
            frontendFeature: FrontendOnlyGuardedFeature.WorkflowAutomationsOptimize,
            availableFromPlanOverwrite: BillingPlanTier.Optimize,
          },
        );
        break;
      default:
        break;
    }
  }

  private getFeature(featureGuard?: FrontendOnlyGuardedFeature): FrontendOnlyGuardedFeature {
    const isLegacyPlan = isBillingPlanLegacy(this.currentPlanTier());

    if (isLegacyPlan) {
      return FrontendOnlyGuardedFeature.WorkflowAutomationsNewPlans;
    }
    if (featureGuard) {
      return featureGuard;
    }
    if (this.currentPlanTier() === BillingPlanTier.Start) {
      return FrontendOnlyGuardedFeature.WorkflowAutomationsAdvance;
    }
    return FrontendOnlyGuardedFeature.WorkflowAutomationsOptimize;
  }
}
